/**
 * 책 및 규칙 / 캠페인 기능의 한국어 사본 카탈로그
 * (`@gamecodex/world-ui` → `features/books`).
 *
 * 키는 기능의 React 컴포넌트에서 호출하는 `t('books.*')`와 일치합니다. 값은
 * i18n 스윕 중에 추출한 원본 한국어 문자열입니다.
 */
export const booksKo = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': '후원자 PDF 받기',
  'books.backerModal.sendLinkError': '지금은 로그인 링크를 보낼 수 없습니다. 잠시 후 다시 시도해주세요.',
  'books.backerModal.checkInboxPrefix': '다음 주소의 받은편지함을 확인하세요',
  'books.backerModal.checkInboxSuffix':
    '해당 이메일로 후원했다면, 로그인 링크가 곧 도착할 것입니다 — 링크를 클릭하여 사본을 받으세요.',
  'books.backerModal.linkAutoSignIn': '링크를 클릭하면 이 사이트에서 자동으로 로그인됩니다. 비밀번호가 필요 없습니다.',
  'books.backerModal.signInIntro':
    '후원할 때 사용한 이메일을 입력하세요. 한 번의 클릭으로 로그인할 수 있는 링크를 보낸 후 개인용 사본을 준비하겠습니다.',
  'books.backerModal.pledgeEmailLabel': '후원 계정 이메일',
  'books.backerModal.emailLinkCta': '로그인 링크를 이메일로 전송',
  'books.backerModal.prepareTimeout':
    '사본을 준비하는 데 예상보다 오래 걸리고 있습니다. 몇 분 후 다시 시도해주세요.',
  'books.backerModal.notEntitled': '로그인했지만, 후원 계획에 이 책이 포함되어 있지 않습니다.',
  'books.backerModal.notClaimable': '이 책은 후원자 다운로드로 제공되지 않습니다.',
  'books.backerModal.prepareError': '지금은 다운로드를 준비할 수 없습니다. 잠시 후 다시 시도해주세요.',
  'books.backerModal.signedInAs': '로그인됨',
  'books.backerModal.signOut': '로그아웃',
  'books.backerModal.verified': '확인됨',
  'books.backerModal.welcomeBack': ' — 돌아오셨습니다,',
  'books.backerModal.backerNumber': '(후원자 #{number})',
  'books.backerModal.copyReady':
    '개인용 사본이 준비되었습니다. 이 링크는 개인 소유이며 곧 만료됩니다 — 공유하지 마세요.',
  'books.backerModal.downloadPdf': 'PDF 다운로드',
  'books.backerModal.dtrpgEmailLabel': 'DriveThruRPG 계정 이메일',
  'books.backerModal.optional': '(선택사항)',
  'books.backerModal.dtrpgWarn':
    '이를 추가하여 구매를 DriveThruRPG 라이브러리로도 동기화할 수 있습니다. 건너뛰면 여전히 여기서 다운로드할 수 있습니다.',
  'books.backerModal.preparingCopy': '사본을 준비 중입니다…',
  'books.backerModal.prepareDownload': '준비 및 다운로드',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': '이 로그인 링크에 토큰이 없습니다. 책 페이지에서 새 링크를 요청하세요.',
  'books.backerVerify.invalidToken':
    '이 로그인 링크가 유효하지 않거나 만료되었습니다. 책 페이지에서 새 링크를 요청하세요.',
  'books.backerVerify.seoTitle': '후원자 로그인',
  'books.backerVerify.seoDescription': 'Grymwyrd 후원자 로그인 링크를 확인 중입니다.',
  'books.backerVerify.confirming': '후원자 로그인을 확인 중입니다…',
  'books.backerVerify.signedInHeading': '로그인되었습니다',
  'books.backerVerify.signedInAs': '로그인됨',
  'books.backerVerify.headBackPrefix': '책으로 돌아가서',
  'books.backerVerify.downloadWord': '다운로드',
  'books.backerVerify.headBackSuffix': '를 클릭하여 사본을 받으세요.',
  'books.backerVerify.backToBook': '책으로 돌아가기',
  'books.backerVerify.browseAthenaeum': '아테나이움 둘러보기',
  'books.backerVerify.problemHeading': '로그인 링크 문제',

  // BookCard.tsx
  'books.card.viewAria': '{title} 보기',
  'books.card.coverAlt': '{title}의 표지',
  'books.card.owned': '소유',

  // BookCover.tsx
  'books.cover.coverAlt': '{title}의 표지',

  // BookStorePage.tsx
  'books.store.seoTitle': '책 및 규칙',
  'books.store.seoDescription':
    '영원한 황혼의 저서 — 핵심 규칙서, 삽화가 그려진 SRD, 그리고 을씨년스러운 모험. 구매하여 모듈을 잠금 해제하고 동전을 획득하세요.',
  'books.store.eyebrow': '아테나이움',
  'books.store.heading': '책 및 규칙',
  'books.store.intro':
    '세계를 하나로 묶는 저서들을 획득하세요. 모든 구매는 캠페인에서 플레이 가능한 모듈을 잠금 해제하고 게임 내 경제를 위한 동전으로 보상됩니다.',
  'books.store.filterAria': '책을 유형별로 필터링',
  'books.store.filterAll': '모두',
  'books.store.loading': '보관소를 개봉 중입니다…',
  'books.store.empty': '이 카테고리와 일치하는 저서가 없습니다. 필경사들이 여전히 작업 중입니다.',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': '지금은 결제가 불가능합니다. 곧 다시 시도해주세요.',
  'books.buy.signInToClaim': '로그인하여 이 저서를 받으세요.',
  'books.buy.ledgerSealed': '상인의 원장이 지금은 봉인되어 있습니다 — 결제가 곧 시작됩니다.',
  'books.buy.inLibrary': '라이브러리에 있음',
  'books.buy.openingVault': '금고를 열고 있습니다…',
  'books.buy.claimFree': '무료로 받기',
  'books.buy.buyPrice': '구매 — {price}',
  'books.buy.unlockPrefix': '구매 → 모듈 잠금 해제 +',
  'books.buy.coinsSuffix': '{coins} 동전',

  // BookDetailPage.tsx
  'books.detail.loading': '페이지를 넘기고 있습니다…',
  'books.detail.backToAthenaeum': '아테나이움으로 돌아가기',
  'books.detail.unlockOwned': '이 저서를 소유하고 있습니다 — 그 Grymwyrd 지식이 백과사전 전체에서 잠금 해제되었습니다.',
  'books.detail.unlockClaim': '이 저서를 받아서 백과사전 전체에서 그 Grymwyrd 지식을 잠금 해제하세요.',
  'books.detail.returnTo': '{label}로 돌아가기',
  'books.detail.backerCta': '후원자신가요? PDF를 다운로드하세요',
  'books.detail.coinsEarned': '이 구매로 {coins} 동전을 획득했습니다.',
  'books.detail.coinsGranted': '구매하면 금고에 {coins} 동전이 지급됩니다.',
  'books.detail.byAuthor': '{author} 작',
  'books.detail.statPrice': '가격',
  'books.detail.statPages': '페이지 (마지막 렌더링)',
  'books.detail.statWords': '단어 (마지막 렌더링)',
  'books.detail.ofThisTome': '이 저서의',
  'books.detail.noDescription': '이 권본에 대한 설명이 아직 기재되지 않았습니다.',
  'books.detail.previewHeading': '미리보기',
  'books.detail.previewBlurb': '이 저서를 받기 전에 샘플을 살펴보세요.',
  'books.detail.readPreview': '미리보기 읽기',
  'books.detail.tocHeading': '목차',
  'books.detail.tocEmpty': '이 저서의 내용이 아직 분류되지 않았습니다.',
  'books.detail.pageAbbrev': 'p. {page}',
  'books.detail.unlockedHeading': '잠금 해제된 백과사전 항목',
  'books.detail.unlockedOwnedNote': '이제 살아있는 백과사전의 일부입니다:',
  'books.detail.unlockedLockedNote':
    '이 저서를 구매하여 생물, 주문, 그리고 비결을 백과사전에 기재하세요 — 그리고',
  'books.detail.coinsAmount': '{coins} 동전',
  'books.detail.attributionsHeading': '저작권 표시 및 라이선스',
  'books.detail.attributionSource': '출처',
  'books.detail.attributionLink': '링크',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': '진행 중인 캠페인',
  'books.campaign.backThisProject': '이 프로젝트에 후원하기',
  'books.campaign.viewStretchGoals': '스트레치 목표 보기',
  'books.campaign.pledged': '후원됨',
  'books.campaign.backers': '후원자',
  'books.campaign.pitchHeading': '피치',
  'books.campaign.backerUnlockedHeading': '후원자 잠금 해제 항목',
  'books.campaign.backerUnlockedBlurb':
    '후원자는 살아있는 백과사전으로 직접 흘러들어오는 콘텐츠에 조기 접근할 수 있습니다. 이미 정설이 된 내용의 샘플입니다:',
  'books.campaign.previewsEmpty': '새로운 정설이 기재되고 있습니다 — 목표가 달성됨에 따라 다시 확인하세요.',
  'books.campaign.choosePledge': '후원 금액 선택',
  'books.campaign.mostBacked': '가장 많이 후원됨',
  'books.campaign.pledgeAmount': '{amount} 후원하기',
  'books.campaign.pledgeFooter':
    '후원은 결제 시 안전하게 처리됩니다. 후원 보상(동전, 모듈, 백과사전 잠금 해제)은 캠페인 서비스가 시작된 후 Grymwyrd 계정에 지급됩니다.',

  // LanguageSelect.tsx
  'books.language.label': '언어',

  // PreviewModal.tsx
  'books.preview.title': '미리보기 — {title}',
  'books.preview.pdfAria': '{title}의 미리보기 PDF',
  'books.preview.cannotDisplay': '마법사가 미리보기를 인라인으로 표시할 수 없습니다.',
  'books.preview.openNewTab': '미리보기를 새 탭에서 열기',
  'books.preview.preparingHeading': '미리보기를 준비 중입니다.',
  'books.preview.preparingBody':
    '이 저서의 샘플을 필경소에서 기재하고 있으며 곧 여기에 나타날 것입니다. 그 동안 그 안에 있는 것을 살펴보세요:',
  'books.preview.excerptLabel': '발췌 — {title}',
  'books.preview.excerptFallback':
    '이 경계 너머에는 공포와 경이로 물든 페이지들이 있습니다. 저서를 획득하여 계속 읽으세요.',
  'books.preview.noExcerpt': '이 권본에 대해 아직 발췌가 분류되지 않았습니다.',

  // RulesPage.tsx
  'books.rules.sectionSpells': '주문',
  'books.rules.sectionMonsters': '괴물',
  'books.rules.sectionMagicItems': '마법 아이템',
  'books.rules.sectionWeapons': '무기',
  'books.rules.sectionArmor': '갑옷',
  'books.rules.sectionSkills': '기능',
  'books.rules.entriesCount': '{entries}개 항목',
  'books.rules.readingLabel': '{label}을 읽고 있습니다…',
  'books.rules.noneCatalogued': '이 시스템에 분류된 {label}이 없습니다.',
  'books.rules.browseAll': '백과사전의 모든 {label} 둘러보기 →',
  'books.rules.seoTitle': '규칙 및 SRD',
  'books.rules.seoDescription':
    '시스템 참조 문서를 둘러보세요 — 주문, 괴물, 아이템 그리고 영원한 황혼을 묶는 규칙들. 지금은 5e SRD이며, 더 많은 시스템이 곧 출시될 예정입니다.',
  'books.rules.eyebrow': '코덱스',
  'books.rules.heading': '규칙 및 시스템 참조',
  'books.rules.intro':
    'Grymwyrd를 구동하는 공개 게임 콘텐츠입니다. 규칙과 관련된 항목을 둘러보고 통계 블록과 지식을 위해 전체 백과사전을 살펴보세요. Grymwyrd는 현재 5e SRD로 제공되며 — PF2e 및 다른 시스템이 곧 출시될 예정입니다.',
  'books.rules.loading': '코덱스를 참고하고 있습니다…',
  'books.rules.gameSystems': '게임 시스템',
  'books.rules.noSystems': '등록된 게임 시스템이 없습니다.',
  'books.rules.openSrd': 'SRD 열기',
  'books.rules.lockedComingSoon': '잠김 — 곧 출시',
  'books.rules.referenceContent': '{name} — 참조 콘텐츠',
  'books.rules.releasedUnder': '{license}에 따라 출시됨',
  'books.rules.licenseLink': '라이선스',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': '{title} 펀딩 진행률',
  'books.stretch.unlockedAdded': '잠금 해제됨 — 백과사전에 추가됨',
  'books.stretch.percentFunded': '{pct}% 펀딩됨',
  'books.stretch.autoPopulates': '백과사전을 자동으로 채웁니다',
  'books.stretch.raisedSoFar': '지금까지 모금된 금액',
  'books.stretch.backers': '후원자',
  'books.stretch.overallAria': '전체 캠페인 펀딩',
  'books.stretch.heading': '스트레치 목표',
} as const
